export default "__VITE_ASSET__BPrb4mzj__"